<template>
  <div class="group relative flex h-15 cursor-pointer items-center gap-2 overflow-hidden px-4 py-2">
    <BaseMemberAvatar :member="member" size="32" />
    <span class="text-title-medium grow truncate">{{ memberFullName(member) }}</span>
    <div class="shrink-0">
      <div v-if="completionPercentage !== 100" class="bg-surface-container-lowest rounded-full p-1">
        <BaseCircularProgressIndictator
          :percentage="completionPercentage"
          :thickness="4"
          :radius="14"
          color="primary"
        />
      </div>
      <div v-else class="relative flex h-7 w-7 items-center justify-center">
        <BaseIcon class="text-on-primary z-10" size="16">check</BaseIcon>
        <BaseShape shape="9-sided-cookie" class="text-primary absolute inset-0 z-0 h-full w-full" />
      </div>
    </div>
    <BaseStateLayer />
  </div>
</template>

<script setup lang="ts">
  import BaseMemberAvatar from '@/core/components/base/avatar/BaseMemberAvatar.vue'
  import BaseCircularProgressIndictator from '@/core/components/base/circlular-progress-indicator/BaseCircularProgressIndictator.vue'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import BaseShape from '@/core/components/base/shapes/BaseShape.vue'
  import BaseStateLayer from '@/core/components/base/state-layer/BaseStateLayer.vue'
  import type { Member } from '@/core/models/member/member'
  import { memberFullName } from '@/core/models/member/member-name'
  import { computed } from 'vue'

  const props = defineProps<{
    member: Member
    totalAnswers: number
    totalQuestions: number
    isActive: boolean
    isFinished: boolean
  }>()

  defineEmits(['select'])

  const completionPercentage = computed(() => {
    if (props.totalQuestions === 0) return 0
    return (props.totalAnswers / props.totalQuestions) * 100
  })
</script>
